import { render, staticRenderFns } from "./for-jev.vue?vue&type=template&id=236bb4fa&"
import script from "./for-jev.vue?vue&type=script&lang=js&"
export * from "./for-jev.vue?vue&type=script&lang=js&"
import style0 from "./for-jev.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports